import { configureStore } from "@reduxjs/toolkit";

import Counter from "./features/Counter";
import Project from "./features/Project";
import User from "./features/User";


export const store = configureStore({
  reducer: {
    counter: Counter,
    user: User,
    project: Project
  }
})
